export const SET_SETTING = (state, setting) => {
    for (let i in setting) {
        state.setting[i] = setting[i];
    }
}
